import * as React from 'react';
import { useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation, Keyboard } from "swiper";
import { motion } from "framer-motion"


import './PreviewCarousel.scss';
import { useEffect } from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
export interface PreviewCarouselProps {
    setCarouselDataWithOpen: any,
    image: any,
    rootData: any,
}

export function PreviewCarousel(props: PreviewCarouselProps) {
    const { setCarouselDataWithOpen, rootData, image } = props;
    const [slideChanged, setSlideChanged] = useState({})

    const [zoomValue, setZoomValue] = useState(1);
    const increaseValue = () => {
        if (zoomValue < 5) {
            setZoomValue((prevValue) => prevValue + 0.4)
        }
    }
    const decreaseValue = () => {
        if (zoomValue >= 0.4) {
            setZoomValue((prevValue) => prevValue - 0.4)
        }
    }








    const setVideoPlayer = (src: any) => {
        const plyrProps: any = {
            source: {
                type: 'video',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'video/mp4',
                        size: 720,
                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'fullscreen'],
                loadSprite: true,
                tooltips: { controls: false, seek: true },
                ratio: '16:9',
                ads: { enabled: false, publisherId: '', tagUrl: '' },
            },
        }

        return (
            plyrProps
        )
    }





    return (
        <motion.div
            initial={{ scale: 0.7 }}
            animate={{ scale: 1 }}
            className={`fixed w-full h-screen overflow-hidden transition-opacity top-0 left-0 z-50 backdrop-blur-xl bg-gray-900 bg-opacity-75`}>
            <div className="w-full h-full relative preview_carousel_box">


                <div className="absolute z-10 right-5 top-5 flex justify-end items-center">
                    <button className="mr-4 mt-1 w-9 h-9 rounded-full bg-[#ffffff99] border border-[#00000040] shadow-md flex justify-center items-center" onClick={increaseValue}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke={zoomValue < 5 ? "#00000080" : "#ffffff50"} strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                        </svg>
                    </button>
                    <button className="mr-4 mt-1 w-9 h-9 rounded-full bg-[#ffffff99] border border-[#00000040] shadow-md flex justify-center items-center" onClick={decreaseValue}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke={zoomValue > 0.4 ? "#00000080" : "#00000050"} strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7" />
                        </svg>
                    </button>

                    <button
                        title="Close"
                        onClick={() => setCarouselDataWithOpen({
                            isOpen: false,
                            image: null,
                            rootData: null,
                        })}
                        className="w-9 h-9 rounded-full bg-[#ffffff99] border border-[#00000040] shadow-md flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="#000000">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>



                <Swiper
                    onSlideChange={e => setSlideChanged(e.clickedIndex)}
                    initialSlide={image.id - 1}
                    pagination={true}
                    cssMode={true}
                    navigation={true}
                    keyboard={true}
                    modules={[Pagination, Navigation, Keyboard]}
                    className="mySwiper h-full"
                >

                    {rootData.map((data: any) =>

                        <SwiperSlide key={data.id} id={`swiperSlide${data.id}`}>
                            <div className="h-full flex justify-center items-center">
                                {data.isVideo
                                    ? <div className="w-11/12 md:w-8/12 h-fit shadow-2xl">
                                        <VideoPlayer plyrProps={setVideoPlayer(data.videoSrc)} />
                                    </div>

                                    : <div className="overflow-hidden h-full w-full flex justify-center items-center">
                                        <img src={data.source} alt="" style={{ transform: `scale(${zoomValue})`, transition: 'all 0.3s ' }} />
                                    </div>
                                }
                            </div>
                        </SwiperSlide>
                    )}







                </Swiper>


            </div>
        </motion.div >
    );
}
